import React from 'react'
import classnames from 'classnames'
import BaseButton from '../Button/BaseButton'

import styles from './RefiOptionCard.module.scss'

interface RefiOptionCardProps {
  children: React.ReactNode
  className?: string
  onClick?: () => void
}
const RefiOptionCard = ({
  children,
  className,
  onClick,
  ...restProps
}: RefiOptionCardProps) => (
  <BaseButton
    element='div'
    onClick={onClick}
    className={classnames(styles.root, className)}
  >
    {children}
  </BaseButton>
)

export default RefiOptionCard
